<!-- <form [formGroup]="formGroup" (ngSubmit)="submit()" autocomplete="off" formName="TransferHistoryDetail" >
	   
	 <box class="entry-form">
	      
			  <app-remarks-control class="col-sm-12 col-lg-6 col-md-12"     label="{{'TransferHistoryDetail.paymentId.label' | translate }}"   formControlName="paymentId" 
   ></app-remarks-control>
	      
			  <app-currency-control  class="col-sm-12 col-lg-6 col-md-12"      label="{{'TransferHistoryDetail.paymentCurrency.label' | translate }}"   formControlName="paymentCurrency" 
   ></app-currency-control>
	      
			  <app-payment-date-control  class="col-sm-12 col-lg-6 col-md-12"     label="{{'TransferHistoryDetail.nextPaymentDate.label' | translate }}"   formControlName="nextPaymentDate" 
      ></app-payment-date-control>
	      
			  <app-remarks-control class="col-sm-12 col-lg-6 col-md-12"    label="{{'TransferHistoryDetail.beneName.label' | translate }}"   formControlName="beneName" 
     ></app-remarks-control>
	      
			  <app-remarks-control  class="col-sm-12 col-lg-6 col-md-12"      label="{{'TransferHistoryDetail.debitAccount.label' | translate }}"   formControlName="debitAccount" 
   ></app-remarks-control>
	      
			  <app-remarks-control  class="col-sm-12 col-lg-6 col-md-12"      label="{{'TransferHistoryDetail.creditAccount.label' | translate }}"   formControlName="creditAccount" 
     ></app-remarks-control>
	      
			  <app-schedule-type-form-control  class="col-sm-12 col-lg-6 col-md-12"      label="{{'TransferHistoryDetail.scheduleType.label' | translate }}"   formControlName="scheduleType" 
     ></app-schedule-type-form-control>
	      
			  <app-remarks   class="col-sm-12 col-lg-6 col-md-12"      label="{{'TransferHistoryDetail.status.label' | translate }}"   formControlName="status" 
     ></app-remarks>
	 </box> 
	</form>
	 -->





<box class="trx-details-container" formName="TransferHistoryDetail">
	<!-- <box class="trx-cover">
		<box class="trx-header">
			<box class="trx-header-logo">
				<ng-container *ngIf="state.popupData?.serviceCode == 'TRANINTBT'; else elseif12">
					<img [src]="'./assets/images/transfers/Within Bank Transfer.svg'">
				</ng-container>
				<ng-template #elseif12>
					<ng-container *ngIf="state.popupData?.serviceCode == 'TRANOAT'; else elseif13">
						<img [src]="'./assets/images/transfers/Own Account Transfer.svg'">
					</ng-container>
				</ng-template>
				<ng-template #elseif13>
					<ng-container *ngIf="state.popupData?.serviceCode == 'TRANDOMESTIC'; else elseif14">
						<img [src]="'./assets/images/transfers/EFT Transfer.svg'">
					</ng-container>
				</ng-template>
			</box>
			<box class="trx-acc-number">
				<span class="account-number">
					{{ state.popupData?.serviceCode=="TRANOAT"?'Own Account':state.popupData?.beneName }}
				</span>
				<box class="trx-nick-name">
					<span class="nick-name">
						<span class="account-name">Ref# : {{state.popupData?.paymentId}}</span>
					</span>
				</box>
			</box>
		</box>

	</box> -->
	<ng-container>
		<div>
			<!-- <div class="trx-deposit-title">
				<h4 class="header-title">Payment Detail</h4>
			</div> -->
			<div class="trx-info-list">

				<div class="trx-info">
					<div class="info-feild">
						<span class="lbl"> Debit Account</span>
						<span class="val">{{ state.popupData?.debitAccount }} </span>
					</div>

				</div>

        <div class="trx-info">
          <div class="info-feild">
			<ng-container *ngIf="state.popupData?.serviceCode =='PAYTOPAYID'">
			<span class="lbl"> PayId</span>
			</ng-container>
			<ng-container *ngIf="state.popupData?.serviceCode !='PAYTOPAYID'">
				<span class="lbl"> Credit Account</span>
				</ng-container>
            <span class="val">{{ state.popupData?.creditAccount }} </span>
          </div>
        </div>
        <ng-container
          *ngIf="state.popupData?.serviceCode == 'TRANINTBT' || state.popupData?.serviceCode=='TRANDOMESTIC'|| state.popupData?.serviceCode=='TRANINTERNATIONAL' || state.popupData?.serviceCode=='PAYTOPAYID'"
        >
          <div class="trx-info">
            <div class="info-feild">
              <span class="lbl"> Beneficiary Name</span>
			  <ng-container *ngIf="state.popupData?.serviceCode=='PAYTOPAYID'">
              <span class="val">{{ (state.popupData?.beneName).substring(0,3)+ "*****"+(state.popupData?.beneName).slice(-3) }} </span>
			  </ng-container>
			  <ng-container *ngIf="state.popupData?.serviceCode!='PAYTOPAYID'">
				<span class="val">{{ state.popupData?.beneName }} </span>
				</ng-container>
            </div>
          </div>
          <ng-container *ngIf="state.popupData?.serviceCode == 'TRANDOMESTIC' && state.popupData?.isAdhoc == '1'">
            <div class="trx-info">
              <div class="info-feild">
                <span class="lbl"> Bank Name</span>
                <span class="val"
                  >{{ state.popupData?.beneBankIdentifier }}
                </span>
              </div>
            </div>
          </ng-container>
		  <ng-container *ngIf="state.popupData?.serviceCode == 'TRANDOMESTIC' && state.popupData?.isAdhoc == '0'">
            <div class="trx-info">
              <div class="info-feild">
                <span class="lbl"> Bank Name</span>
                <span class="val"
                  >{{ state.popupData?.bankCode }}
                </span>
              </div>
            </div>
          </ng-container>
		  <ng-container *ngIf="state.popupData?.serviceCode == 'TRANINTERNATIONAL' && state.popupData?.beneBankIdentifier != ''">
            <div class="trx-info">
              <div class="info-feild">
                <span class="lbl"> Bank Name</span>
                <span class="val"
                  >{{ state.popupData?.beneBankIdentifier }}
                </span>
              </div>
            </div>
          </ng-container>
		  <ng-container *ngIf="state.popupData?.serviceCode == 'TRANINTERNATIONAL' && state.popupData?.bankCode != ''">
            <div class="trx-info">
              <div class="info-feild">
                <span class="lbl"> Bank Name</span>
                <span class="val"
                  >{{ state.popupData?.bankCode }}
                </span>
              </div>
            </div>
          </ng-container>
        </ng-container>

				<!-- <div class="trx-info">
					<div class="info-feild">
						<span class="lbl"> Reference Number</span>
						<span class="val">{{ state.popupData?.paymentId }} </span>
					</div>

				</div> -->

				<div class="trx-info">
					<div class="info-feild">
						<span class="lbl"> Payment Amount</span>
						<span class="val">
							<span class="amount">
								{{ state.popupData?.paymentAmount | currency: state.popupData?.paymentCurrency:"" }}

								<em class="currency"> {{ state.popupData?.paymentCurrency || "USD" }}</em>
							</span>
						</span>
					</div>

				</div>

				<div class="trx-info">
					<div class="info-feild">
						<span class="lbl">Transfer Type</span>
						<ng-container *ngIf="state.popupData?.serviceCode  =='TRANOAT'">
							<span class="val">Own Account Transfer</span>
						</ng-container>
						<ng-container *ngIf="state.popupData?.serviceCode =='TRANINTBT'">
							<span class="val">Within Bank Transfer</span>
						</ng-container>
						<ng-container *ngIf="state.popupData?.serviceCode =='PAYTOPAYID'">
							<span class="val">Pay To PayId</span>
						</ng-container>
						<ng-container *ngIf="state.popupData?.serviceCode =='TRANDOMESTIC'">
							<span class="val">Domestic Transfer</span>
						</ng-container>
						<ng-container *ngIf="state.popupData?.serviceCode =='TRANDOMKATS'">
							<span class="val">Domestic Transfer</span>
						</ng-container>
						<ng-container *ngIf="state.popupData?.serviceCode =='TRANINTERNATIONAL'">
							<span class="val">International Transfer</span>
						</ng-container>
					</div>
				</div>
				<div class="trx-info">
					<div class="info-feild">
						<span class="lbl">Status</span>
						<ng-container *ngIf="state.popupData?.status  =='S'">
							<span class="val">Success</span>
						</ng-container>
						<ng-container *ngIf="state.popupData?.status =='F'">
							<span class="val">Failed</span>
						</ng-container>
						<ng-container *ngIf="state.popupData?.status =='I'">
							<span class="val">Initiated</span>
						</ng-container>
						<ng-container *ngIf="state.popupData?.status =='P'">
							<span class="val">Pending</span>
						</ng-container>
					</div>
				</div>
				<ng-container *ngIf="state.popupData?.serviceCode !='PAYTOPAYID' && state.popupData?.scheduleType != ''">
				<div class="trx-info">
					<div class="info-feild">
						<span class="lbl">Payment Option</span>
						<ng-container *ngIf="state.popupData?.scheduleType =='1'">
							<span class="val">Pay Now</span>
						</ng-container>
						<ng-container *ngIf="state.popupData?.scheduleType =='2'">
							<span class="val">Pay Later</span>
						</ng-container>
						<ng-container *ngIf="state.popupData?.scheduleType =='3'">
							<span class="val">Recurring</span>
						</ng-container>
					</div>
				</div>
				</ng-container>
				<ng-container>
					<div class="trx-info">
						<div class="info-feild">
				              <ng-container *ngIf="state.popupData?.scheduleType == '1'">
				                <span class="lbl">Payment Date</span>
				                <span class="val"
				                  >{{ state.popupData?.createdOn | date: "dd/MM/yyyy HH:MM:ss" }}
				                </span>
				              </ng-container>
				              <ng-container *ngIf="state.popupData?.scheduleType == '2'">
				                <span class="lbl">Payment Date</span>
				                <span class="val"
				                  >{{ state.popupData?.paymentDate | date: "dd/MM/yyyy HH:MM:ss" }}
				                </span>
				              </ng-container>
				              <ng-container *ngIf="state.popupData?.scheduleType == '3'">
				                <span class="lbl">Next Payment Date</span>
				                <span class="val"
				                  >{{ state.popupData?.nextPaymentDate | date: "dd/MM/yyyy HH:MM:ss" }}
				                </span>
				              </ng-container>
						</div>
					</div>
				</ng-container>
				<div class="trx-info" *ngIf="state.popupData?.frequency">
					<div class="info-feild">
						<span class="lbl"> Payment Frequency</span>
						<ng-container *ngIf="state.popupData?.frequency =='1'">
							<span class="val">Daily</span>
						</ng-container>
						<ng-container *ngIf="state.popupData?.frequency =='2'">
							<span class="val">Monthly</span>
						</ng-container>
						<ng-container *ngIf="state.popupData?.frequency =='3'">
							<span class="val">Yearly</span>
						</ng-container>
					</div>

				</div>
				<div class="trx-info" *ngIf="state.popupData?.noOfInstallment">
					<div class="info-feild">
						<span class="lbl">No Of Installment</span>
						<span class="val">{{ state.popupData?.noOfInstallment }} </span>
					</div>

				</div>

				<div class="trx-info" *ngIf="state.popupData?.endDate">
					<div class="info-feild">
						<span class="lbl">End Date</span>
						<span class="val">{{ state.popupData?.endDate | date: "dd/MM/yyyy"  }} </span>
					</div>
				</div>

			</div>
		</div>
	</ng-container>

	<ng-template #loader>
		<div class="data-loading">
			<img src="./assets/images/data-loader.svg" alt="loading..." />
		</div>
	</ng-template>
</box>